import { generateColorScheme, reverseColor } from "../utils/colors.js";
import { defaultPrimaryColor } from "../theme/colors/primary.js";
import { defaultSecondaryColor } from "../theme/colors/secondary.js";
import { theme } from "../theme/index.js";
import { useColorTheme } from "../providers/ColorThemeProvider.js";
import { c } from "react-compiler-runtime";

//#region src/hooks/useColors.ts
const useColors = (t0) => {
	const $ = c(33);
	const { primaryColor: t1, secondaryColor: t2 } = t0;
	const primaryColor = t1 === void 0 ? defaultPrimaryColor : t1;
	const secondaryColor = t2 === void 0 ? defaultSecondaryColor : t2;
	const { colorMode } = useColorTheme();
	const isDarkMode = colorMode === "dark";
	let t3;
	if ($[0] !== isDarkMode || $[1] !== primaryColor) {
		t3 = generateColorScheme({
			color: primaryColor,
			reverse: isDarkMode
		});
		$[0] = isDarkMode;
		$[1] = primaryColor;
		$[2] = t3;
	} else t3 = $[2];
	let t4;
	if ($[3] !== t3) {
		t4 = {
			...theme.colors.primary,
			...t3
		};
		$[3] = t3;
		$[4] = t4;
	} else t4 = $[4];
	let t5;
	if ($[5] !== isDarkMode || $[6] !== secondaryColor) {
		t5 = generateColorScheme({
			color: secondaryColor,
			reverse: isDarkMode
		});
		$[5] = isDarkMode;
		$[6] = secondaryColor;
		$[7] = t5;
	} else t5 = $[7];
	let t6;
	if ($[8] !== t5) {
		t6 = {
			...theme.colors.secondary,
			...t5
		};
		$[8] = t5;
		$[9] = t6;
	} else t6 = $[9];
	let t7;
	if ($[10] !== isDarkMode) {
		t7 = isDarkMode ? {
			...theme.colors["dark-neutral"],
			white: theme.colors["dark-neutral"]["200"],
			50: theme.colors["dark-neutral"]["300"],
			100: theme.colors["dark-neutral"]["400"],
			300: theme.colors["dark-neutral"]["500"],
			500: theme.colors["dark-neutral"]["700"]
		} : theme.colors.neutral;
		$[10] = isDarkMode;
		$[11] = t7;
	} else t7 = $[11];
	const t8 = isDarkMode ? theme.colors["dark-neutral"]["200"] : theme.colors.neutral.white;
	const t9 = isDarkMode ? theme.colors["dark-neutral"]["200"] : theme.colors["white-fixed"];
	let t10;
	if ($[12] !== isDarkMode) {
		t10 = isDarkMode ? reverseColor(theme.colors.error) : theme.colors.error;
		$[12] = isDarkMode;
		$[13] = t10;
	} else t10 = $[13];
	let t11;
	if ($[14] !== isDarkMode) {
		t11 = isDarkMode ? reverseColor(theme.colors.success) : theme.colors.success;
		$[14] = isDarkMode;
		$[15] = t11;
	} else t11 = $[15];
	let t12;
	if ($[16] !== isDarkMode) {
		t12 = isDarkMode ? reverseColor(theme.colors.warning) : theme.colors.warning;
		$[16] = isDarkMode;
		$[17] = t12;
	} else t12 = $[17];
	let t13;
	if ($[18] !== isDarkMode) {
		t13 = isDarkMode ? reverseColor(theme.colors.information) : theme.colors.information;
		$[18] = isDarkMode;
		$[19] = t13;
	} else t13 = $[19];
	let t14;
	if ($[20] !== isDarkMode) {
		t14 = isDarkMode ? {
			purple: reverseColor(theme.colors.tertiary.purple),
			pink: reverseColor(theme.colors.tertiary.pink),
			yellow: reverseColor(theme.colors.tertiary.yellow),
			litblue: reverseColor(theme.colors.tertiary.litblue),
			orange: reverseColor(theme.colors.tertiary.orange),
			turquoise: reverseColor(theme.colors.tertiary.turquoise)
		} : theme.colors.tertiary;
		$[20] = isDarkMode;
		$[21] = t14;
	} else t14 = $[21];
	let t15;
	if ($[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t13 || $[26] !== t14 || $[27] !== t4 || $[28] !== t6 || $[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
		t15 = {
			...theme.colors,
			primary: t4,
			secondary: t6,
			neutral: t7,
			white: t8,
			"white-fixed": t9,
			error: t10,
			success: t11,
			warning: t12,
			information: t13,
			tertiary: t14
		};
		$[22] = t10;
		$[23] = t11;
		$[24] = t12;
		$[25] = t13;
		$[26] = t14;
		$[27] = t4;
		$[28] = t6;
		$[29] = t7;
		$[30] = t8;
		$[31] = t9;
		$[32] = t15;
	} else t15 = $[32];
	return t15;
};

//#endregion
export { useColors };
//# sourceMappingURL=useColors.js.map